<div class="flex justify-between items-center">
	<div class="flex items-center">Deposit</div>
	<app-button btn="tertiary" (click)="openDepositModal()" class="ml-3">{{
		depositTotal?.absAmount | centsToDollars
	}}</app-button>
</div>
